import React, { Component } from 'react';
import { Table, Input, Label, Row, Col, Form } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';


class EmployeeStartTimesDateToDate extends Component {
    constructor(props) {
        super(props);
        const selectorArr = this.props.selector != null ? this.props.selector.split('/') : [];
        this.state = {
            employees: [],
            employeeId: selectorArr.length > 0 ? parseInt(selectorArr[0]) : 0,
            teams: [],
            team: selectorArr.length > 1 ? parseInt(selectorArr[1]) : 0,
            startDate: selectorArr.length > 2 ? selectorArr[2] : this.formatDateForInput(new Date().toISOString()),
            endDate: selectorArr.length > 3 ? selectorArr[3] : this.formatDateForInput(new Date().toISOString()),
            showWeekends: selectorArr.length > 4 ? selectorArr[4] === 'true' : false,
            data: [],
            dateArray: []
        };
    }

    componentDidMount() {
        this.props.log('EmployeeStartTimesDateToDate.js/componentDidMount');
        this.getTeams();
        this.onSubmit();
    }

    getTeams = () => {
        this.props.log('EmployeeStartTimesDateToDate.js/getTeams');
        fetch('/api/teams/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        teams: results.data,
                    });
                } else {
                    this.props.addToast('Unable to load teams.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onSubmit = () => {
        this.props.log('EmployeeStartTimesDateToDate.js/onSubmit');
        if (this.state.startDate == null || this.state.startDate === '') return;
        const dateArray = this.getDates(this.state.startDate, (this.state.endDate !== '' ? this.state.endDate : this.state.startDate))
            .filter(date => (this.state.showWeekends || (!this.state.showWeekends && (new Date(date + 'T00:00:00').getDay() !== 0 && new Date(date + 'T00:00:00').getDay() !== 6))));
        this.setState({
            dateArray: dateArray
        })
        fetch('/api/reports/EmployeeStartTime', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
            body: JSON.stringify([
                { key: 'startDate', type: 'date', value: this.state.startDate },
                { key: 'endDate', type: 'date', value: this.state.endDate !== '' ? this.state.endDate : this.state.startDate },
                { key: 'team', type: 'int', value: this.state.team },
                { key: 'employeeId', type: 'int', value: this.state.employeeId }
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    let data = results.data[0].employees.map(employee => {
                        let innerData = dateArray.map((date, dateIndex) => {
                            if (results.data[0].dates != null && results.data[0].dates.filter(item => item.date === date).length > 0) {
                                if (results.data[0].dates.filter(item => item.date === date)[0].times != null &&
                                    results.data[0].dates.filter(item => item.date === date)[0].times
                                        .filter(item => item.employeeId === employee.employeeId).length > 0) {
                                    let retStr = '';
                                    if (results.data[0].dates.filter(item => item.date === date)[0].times.filter(item => item.employeeId === employee.employeeId)[0].startTime != null &&
                                        results.data[0].dates.filter(item => item.date === date)[0].times.filter(item => item.employeeId === employee.employeeId)[0].startTime !== '') retStr += this.getTime(String(results.data[0].dates.filter(item => item.date === date)[0].times.filter(item => item.employeeId === employee.employeeId)[0].startTime).substring(0, 5));
                                    if (results.data[0].dates.filter(item => item.date === date)[0].times.filter(item => item.employeeId === employee.employeeId)[0].startTime != null &&
                                        results.data[0].dates.filter(item => item.date === date)[0].times.filter(item => item.employeeId === employee.employeeId)[0].startTime !== '' &&
                                        results.data[0].dates.filter(item => item.date === date)[0].times.filter(item => item.employeeId === employee.employeeId)[0].status != null &&
                                        results.data[0].dates.filter(item => item.date === date)[0].times.filter(item => item.employeeId === employee.employeeId)[0].status !== '') retStr += ' (';
                                    if (results.data[0].dates.filter(item => item.date === date)[0].times.filter(item => item.employeeId === employee.employeeId)[0].status != null &&
                                        results.data[0].dates.filter(item => item.date === date)[0].times.filter(item => item.employeeId === employee.employeeId)[0].status !== '') retStr += results.data[0].dates.filter(item => item.date === date)[0].times.filter(item => item.employeeId === employee.employeeId)[0].status;
                                    if (results.data[0].dates.filter(item => item.date === date)[0].times.filter(item => item.employeeId === employee.employeeId)[0].startTime != null &&
                                        results.data[0].dates.filter(item => item.date === date)[0].times.filter(item => item.employeeId === employee.employeeId)[0].startTime !== '' &&
                                        results.data[0].dates.filter(item => item.date === date)[0].times.filter(item => item.employeeId === employee.employeeId)[0].status != null &&
                                        results.data[0].dates.filter(item => item.date === date)[0].times.filter(item => item.employeeId === employee.employeeId)[0].status !== '') retStr += ')';
                                    return retStr;
                                } else {
                                    return '';
                                }
                            } else {
                                return '';
                            }
                        });
                        innerData.unshift(this.getTime(employee.startTime));
                        if (employee.departments != null) innerData.unshift(JSON.parse(employee.departments).join(', '));
                        innerData.unshift(employee.team);
                        innerData.unshift(employee.lastName + ', ' + employee.firstName);
                        return innerData
                    })
                    this.setState({
                        data: data,
                        employees: results.data[0].employees
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
        // .catch(() => {
        //     this.props.addToast('An error has occurred.', 5, 'danger');
        // })
    }

    getCSVdata = () => {
        this.props.log('EmployeeStartTimesDateToDate.js/getCSVdata');
        let retArray = [['Employee'].concat(this.state.dateArray.map(date => (
            this.formatDate(date)
        )))];
        retArray = retArray.concat(this.state.data.filter(employee => this.state.employeeId === 0 || employee[0] === (this.state.employees.filter(e => e.employeeId === this.state.employeeId)[0].lastName + ', ' + this.state.employees.filter(e => e.employeeId === this.state.employeeId)[0].firstName)));
        // retArray = retArray.concat(this.state.data.map(row => row.map((item,index) => index > 0 ? this.getTime(item,index) : item)));
        this.props.passData(retArray, "employee-start-times");
    }

    formatDate = (d) => {
        this.props.info('EmployeeStartTimesDateToDate.js/formatDate (d)', d);
        if (parseInt(String(d).substring(0, 4)) <= 2000) return "";
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return String(days[new Date(d + 'T00:00:00').getDay()]).substring(0, 3) + '. ' + parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10))//+'/'+parseInt(String(d).substring(0,4));
    }

    formatDateForInput = (d) => {
        this.props.info('EmployeeStartTimesDateToDate.js/formatDateForInput (d)', d);
        return String(d).substring(0, 4) + '-' + (String(d).substring(5, 7)) + '-' + (String(d).substring(8, 10));
    }

    addDays = (date, days) => {
        this.props.info('EmployeeStartTimesDateToDate.js/addDays (date, days)', date, days);
        var d = new Date(date.valueOf())
        d.setDate(d.getDate() + days);
        return d;
    }

    getTime = (time, index) => {
        this.props.info('EmployeeStartTimesDateToDate.js/getTime (time,index)', time, index);
        if (time === '' || time == null) return '';
        if (index === 0) return time;
        if (time == null || time === '') return '';
        var hours = parseInt(time.substring(0, 2)),
            minutes = parseInt(time.substring(3, 5)),
            ampm = 'am';
        if (hours === 12) {
            ampm = 'pm';
        } else if (hours === 0) {
            hours = 12;
        } else if (hours > 12) {
            hours -= 12;
            ampm = 'pm';
        }
        return hours + ':' + String(minutes).padStart(2, '0') + ' ' + ampm;
    }

    strToTime = (time) => {
        this.props.info('EmployeeStartTimesDateToDate.js/strToTime (time)', time);
        if (time === '' || time == null) return -1;
        let hour = parseInt(time.split(':')[0]);
        let minutes = parseInt(time.split(' ')[0].split(':')[1]);
        let pm = time.split(' ')[1] === 'pm';
        if (hour === 12 && !pm) hour = 0;
        if (pm) hour += 12;
        let retDate = Date.parse('2000-01-01T' + String(hour).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':00');
        if (isNaN(retDate)) return -1;
        return retDate;
    }

    getDates = (startDate, endDate) => {
        this.props.info('EmployeeStartTimesDateToDate.js/getDates (startDate, endDate)', startDate, endDate);
        if (typeof (startDate) === 'string') startDate = new Date(startDate);
        if (typeof (endDate) === 'string') endDate = new Date(endDate);
        var dateArray = [];
        while (startDate <= endDate) {
            dateArray.push(startDate)
            startDate = this.addDays(startDate, 1);
        }
        return dateArray.map(date => date.toISOString().substring(0, 10));
    }

    setSelector = () => {
        this.props.log('EmployeeStartTimesDateToDate.js/setSelector');
        this.props.changeSelector({
            target: {
                value: this.state.employeeId + '/' + this.state.team + '/' + this.state.startDate + '/' + this.state.endDate + '/' + this.state.showWeekends
            }
        });
    }

    compare = (startTime, time) => {
        this.props.info('EmployeeStartTimesDateToDate.js/compare (startTime, time)', startTime, time);
        if (startTime === -1 || time === -1 ) return '';
        return (startTime + (1000 * 60 * 5) - time < 0) ? 'font-weight-bold' : '';
    }

    render() {
        this.props.info('EmployeeStartTimesDateToDate.js/render');
        return (
            <>
                <Row>
                    <Col>
                        <Form inline>
                            <Input type="select" value={this.state.employeeId} onChange={(e) => this.setState({ employeeId: parseInt(e.target.value), team: 0 }, () => { this.onSubmit(); this.setSelector(); })} >
                                <option value="0">All Employees</option>
                                {this.state.employees.map(employee => (
                                    <option key={employee.employeeId}
                                        value={employee.employeeId}>{employee.lastName}, {employee.firstName}</option>
                                ))}
                            </Input>
                            <Input className="ml-4" type="select" value={this.state.team} onChange={(e) => this.setState({ team: parseInt(e.target.value), employeeId: 0 }, () => { this.onSubmit(); this.setSelector(); })} >
                                <option value="0">All Teams</option>
                                {[...this.state.teams].filter(team => team.active).map(team => (
                                    <option key={"teamIndividualResponsibilities_team_" + team.id}
                                        value={team.id}>{team.teamName}</option>
                                ))}
                            </Input>
                            <Label className='ml-4'>Date: <Input className='ml-2' type="date" value={this.state.startDate} onChange={(e) => this.setState({ startDate: e.target.value }, () => { this.onSubmit(); this.setSelector(); })} /></Label>
                            <Label className='ml-4'>Date Through (optional): <Input className='ml-2' type="date" value={this.state.endDate} onChange={(e) => this.setState({ endDate: e.target.value }, () => { this.onSubmit(); this.setSelector(); })} /></Label>
                            <Label className='ml-4'>Show Weekends? <Input className='ml-2' type="checkbox" checked={this.state.showWeekends} onChange={() => this.setState({ showWeekends: !this.state.showWeekends }, () => { this.onSubmit(); this.setSelector(); })} /></Label>
                        </Form>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Table className="mw-100 w-25 mt-4">
                            <thead>
                                <tr>
                                    <th>Employee</th>
                                    <th>Team</th>
                                    <th>Department(s)</th>
                                    <th className="tableCellDate">Start Time</th>
                                    {this.state.dateArray.map(date => (
                                        <th className="tableCellDate" key={date}>{this.formatDate(date)}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.data.filter(employee => this.state.employeeId === 0 ||
                                    employee[0] === (
                                        (this.state.employees.filter(e => e.employeeId === this.state.employeeId).length > 0 ?
                                            this.state.employees.filter(e => e.employeeId === this.state.employeeId)[0].lastName : ''
                                        )
                                        + ', ' +
                                        (this.state.employees.filter(e => e.employeeId === this.state.employeeId).length > 0 ?
                                            this.state.employees.filter(e => e.employeeId === this.state.employeeId)[0].firstName : ''
                                        )
                                    )
                                ).map((employee, employeeIndex) => (
                                    <tr key={employeeIndex}>
                                        {employee.map((date, dateIndex) => (
                                            <td className={this.compare(this.strToTime(employee[3]), this.strToTime(date))} key={dateIndex}>{date}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </>
        );

    }
}

export default EmployeeStartTimesDateToDate;
